import React, { Component } from "react";
import Image from '../global/Image';

export default class PageGettingHere extends Component {
	
		
	render() {
		
		let post = this.props.post;
		
		if (post.gh_heading && post.gh_image_src && post.gh_text) {
			
			return (				
				
				<div id="getting-here" className="c-getting-here">
					<div className="c-getting-here__inner">
						<h2 className="c-getting-here__heading" dangerouslySetInnerHTML={{__html:post.ls_heading}}></h2>
						<div className="c-getting-here__image">
							<Image width={post.gh_image_width} height={post.gh_image_height} srcset={post.gh_image_srcset} src={post.gh_image_src} />
						</div>
						<h3 className="c-getting-here__address" dangerouslySetInnerHTML={{__html:post.gh_address}}></h3>
						<div className="c-getting-here__columns">
							<div className="c-getting-here__left">
								{post.gh_text &&
									<div className="scope-text" dangerouslySetInnerHTML={{__html:post.gh_text}}></div>
								}
							</div>
							<div className="c-getting-here__right">
								{post.gh_button_text && post.gh_button_url &&
									<a href={post.gh_button_url} className="c-getting-here__button" dangerouslySetInnerHTML={{__html:post.gh_button_text}}></a>
								}
							</div>
						</div>
					</div>					
				</div>			
									
			);
			
		} else {
			return null;
		}
	}
}